export const ToastMessages = {
  CASE_INITIATION_SUBMIT_SUCCESS: "Case initiation submitted successfully",
  CASE_INITIATION_SUBMIT_ERROR: "Case initiation submission failed",
  CASE_INITIATION_NO_FILE: "Please upload a file",
  CASE_INITIATION_NO_ORG_ID: "Organization ID not found",
  CASE_INITIATION_NO_MRN: "MRN not found",
  CASE_INITIATION_NO_DOB: "DOB not found",
  CASE_INITIATION_NO_FIRST_NAME: "First name not found",
  CASE_INITIATION_NO_LAST_NAME: "Last name not found",
  CASE_INITIATION_NO_PRESCRIBER_NAME: "Prescriber name not found",
  CASE_INITIATION_NO_DRUG_NAME: "Drug name not found",
  CASE_INITIATION_NO_KEY: "Key not found",
  CASE_INITIATION_FILE_SIZE_ERROR: "File size is too large",
  TEMPLATE_DOWNLOAD_ERROR: "Failed to download template",
  TEMPLATE_DOWNLOAD_SUCCESS: "Template downloaded successfully",
  FORM_CONFIG_SAVE_SUCCESS: "Form config saved successfully!",
  FORM_CONFIG_SAVE_FAILURE: "Error saving form config. Please try again.",
  FORM_CONFIGURATION_UPDATE_SUCCESS: "Form configuration updated successfully!",
  FORM_CONFIGURATION_UPDATE_FAILURE:
    "Error updating form configuration. Please try again.",
  FORM_CONFIGURATION_NOT_AVAILABLE: "Form configuration error",
  STAT_FILE_UPLOAD_NO_FILE: "Please upload a CSV file",
  STAT_FILE_UPLOAD_SUCCESS: "Stat file uploaded successfully",
  STAT_FILE_UPLOAD_ERROR: "Stat file upload failed. Please try again.",
};
